import Layout from '@/layout/ezpay-index.vue'

export const financialRouter = {
  path: '/financialManage',
  component: Layout,
  redirect: '/financialManage/balance',
  name: 'Financial_Manage',
  meta: { title: 'financial', icon: 'financials' },
  alwaysShow: true,
  children: [
    {
      path: 'balance',
      name: 'Financial_Manage_Balance',
      component: () => import('@/views/ezpay/data/balance.vue'),
      meta: {
        title: 'account_balance', noCache: false,
        auth: ['AUTH_CODE_BALANCE']
      }
    },
    {
      path: 'setting',
      name: 'Financial_Manage_Setting',
      component: () => import('@/views/ezpay/data/financial-setting.vue'),
      meta: {
        title: 'financial_setting', noCache: false,
        auth: ['AUTH_CODE_FINANCIALS_SETTING']
      }
    },
    {
      path: 'balance/detail',
      name: 'Financial_Manage_Balance_Detail',
      component: () => import('@/views/ezpay/data/balance-trans-detail.vue'),
      meta: {
        title: 'balance_details', noCache: false,
        auth: ['AUTH_CODE_BALANCE'],
        activeMenu: '/financialManage/balance'
      },
      hidden: true
    }
  ]
}

export const financialAgentRouter = {
  path: '/financialManage/agent',
  component: Layout,
  redirect: '/financialManage/agent/balance',
  name: 'Financial_Manage',
  meta: { title: 'financial', icon: 'financials' },
  alwaysShow: true,
  children: [
    {
      path: 'balance',
      name: 'Financial_Manage_Agent_Balance',
      component: () => import('@/views/ezpay/financials-agent/balance.vue'),
      meta: {
        title: 'balance', noCache: false,
        auth: ['ROLE_AUTH_AGENT_ADMIN']
      }
    },
    {
      path: 'setting',
      name: 'Financial_Manage_Agent_Setting',
      component: () => import('@/views/ezpay/data/financial-setting.vue'),
      meta: {
        title: 'financial_setting', noCache: false,
        auth: ['ROLE_AUTH_AGENT_ADMIN']
      }
    },
    {
      path: 'balance/detail',
      name: 'Financial_Manage_Agent_Balance_Detail',
      component: () => import('@/views/ezpay/financials-agent/balance-trans-detail.vue'),
      meta: {
        title: 'balance_details', noCache: false,
        auth: ['ROLE_AUTH_AGENT_ADMIN'],
        activeMenu: '/financialManage/agent/balance'
      },
      hidden: true
    }
  ]
}
